import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../axios";

const initialState = {
  location: [],
  loading: false,
  data: null,
  error: null,
  bookingInfo: {
    pickUp: null,
    dropOff: null,
    userToggle:false,
  },
  personalDetailsData: {
    name: "",
    emailId: "",
    phone: "",
    address: "",
    phoneNumber:"",
    countryCode:"",
  },
  documentsData: {
    idFront: "",
    licence: "",
  },

  // withDriver: true,
  withDriver: null,
  bookCarStatus: "",
  bookCarData: [],
  bookingImageObj: {
    idFront: "",
    licenceFront: "",
  },
  carId: "",
  rent: {
    driverRent: null,
    carRent: null,
  },
  userBooking: {},
  cancelBooking: {},
  bookingAmount: null,
  bookingDays: null,
  bookingvalidationResponse: null,
  completeBookingResponse: null,
  //   stripeSession: {},
};

const config = {
  headers: {
    key: "KwachaRides-api-secret-key",
    // 'Content-Type': 'multipart/form-data',
  },
};
const configForm = {
  headers: {
    // "key": "KwachaRides-api-secret-key",
    "Content-Type": "multipart/form-data",
  },
};

export const checkBookingValidation = createAsyncThunk(
  "checkBookingValidation",
  async (data) => {
    try {
      const response = await axios.post(`/booking/checkBooking`, data);

      return response;
    } catch (error) {
      // Handle the error here
      console.error(error);
      throw error;
    }
  }
);

export const stripeSessionGet = createAsyncThunk(
  "stripeSessionGet",
  async (id) => {
    try {
      const response = await axios.get(`/pay/checkout/sessions/${id}`);
      return response;
    } catch (error) {
      // Handle the error here
      console.error(error);
      throw error;
    }
  }
);
export const bookCar = createAsyncThunk("bookCar", async (data) => {
  console.log(data,"data")
  try {
    const response = await axios.post(`/booking/bookacar`, data,
      //  configForm
      );
    return response;
  } catch (error) {
    // Handle the error here
    console.error(error);
    return error;
    // throw error;
  }
});
export const fetchUserBooking = createAsyncThunk(
  "fetchUserBooking",
  async (data) => {
    try {
      const response = await axios.post(
        `/booking/fetchuserbooking`,
        data,
        config
      );
      return {
        status: response.status,
        data: response.data,
      };
    } catch (error) {
      // Handle the error here
      console.error(error);
      throw error;
    }
  }
);

export const cancelBooking = createAsyncThunk("cancelBooking", async (data) => {
  try {
    const response = await axios.post(`/booking/cancelBooking`, data, config);
    return response;
  } catch (error) {
    // Handle the error here
    console.error(error);
    throw error;
  }
});
export const uploadDocImages = createAsyncThunk(
  "uploadDocImages",
  async (data) => {
      try {
          const response = await axios.post('/car/uploadImage',data, config)
          return response.data;
      } catch (error) {
          return error.response.data.errors
      }
  });

export const completeBookingByUser = createAsyncThunk(
  "completeBookingByUser",
  async (data) => {
    try {
      const response = await axios.post(
        `/booking/completeBookingByUser`,
        data,
        config
      );
      return response;
    } catch (error) {
      // Handle the error here
      console.error(error);
      throw error;
    }
  }
);

export const getLocation = createAsyncThunk("getLocation", async () => {
  const response = await axios.get(`/location/fetchalllocation`, config);
  return response?.data;
});

// export const getBookingPayment = createAsyncThunk('getBookingPayment', async () => {
//     try {
//         const response = await axios.get('https://api.example.com/data');
//         return response.data;
//     } catch (error) {
//         // Handle the error here
//         console.error(error);
//         throw error;
//     }
// });

const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    setBookingData: (state, action) => {
      state.bookingInfo = action.payload;
    },
    setPersonalDetailsData: (state, action) => {
      state.personalDetailsData = action.payload;
    },
    setDocumentsData: (state, action) => {
      state.documentsData = action.payload;
    },
    setBookingImageObj: (state, action) => {
      state.bookingImageObj = action.payload;
    },
    setWithDriver: (state, action) => {
      state.withDriver = action.payload;
    },
    setCarId: (state, action) => {
      state.carId = action.payload;
    },
    setCarRent: (state, action) => {
      state.rent = action.payload;
    },
    cleanBookingData: (state) => {
      state.bookingInfo = {
        pickUp: "",
        dropOff: "",
        bookingInfoData:false
      };
      state.documentsData = {
        idFront: "",
        licence: "",
      };
      state.personalDetailsData = {
        name: "",
        emailId: "",
        phone: "",
        address: "",
        phoneNumber:"",
        countryCode:"",
      };
      state.bookCarStatus = "";
      state.bookingDays = null;
      state.bookingvalidationResponse = null;
      state.withDriver = null;
    },
    cleanBookingDataWithFilter: (state) => {
      // state.bookingInfo = {
      //   pickUp: "",
      //   dropOff: "",
      // };
      state.documentsData = {
        idFront: "",
        licence: "",
      };
      // below clear serch address
      // state.personalDetailsData = {
      //   name: "",
      //   emailId: "",
      //   phone: "",
      //   address: "",
      // };
      state.bookCarStatus = "";
      state.bookingDays = null;
      state.bookingvalidationResponse = null;
    },
    clearBookCarData: (state) => {
      state.bookCarData = [];
    },
    setBookingAmount: (state, action) => {
      state.bookingAmount = action?.payload;
    },
    setBookingDays: (state, action) => {
      state.bookingDays = action?.payload;
    },
    cleanCompleteBookingResponse: (state) => {
      state.completeBookingResponse = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLocation.fulfilled, (state, action) => {
        state.location = action?.payload?.data;
      })
      .addCase(bookCar.pending, (state, action) => {
        state.bookCarStatus = "pending";
        state.bookCarData = action.payload;
      })
      .addCase(bookCar.fulfilled, (state, action) => {
        state.bookCarData = action.payload;
        state.bookCarStatus = "success";
      })
      .addCase(bookCar.rejected, (state, action) => {
        state.bookCarStatus = "failed";
        state.bookCarData = action.payload;
      })
      .addCase(fetchUserBooking.pending, (state, action) => {
        state.userBooking = action.payload;
      })
      .addCase(fetchUserBooking.fulfilled, (state, action) => {
        state.userBooking = action.payload;
        state.cancelBooking = {};
      })
      .addCase(fetchUserBooking.rejected, (state, action) => {
        state.userBooking = action.payload;
      })
      .addCase(cancelBooking.pending, (state, action) => {
        state.cancelBooking = action.payload;
      })
      .addCase(cancelBooking.fulfilled, (state, action) => {
        state.cancelBooking = action.payload;
      })
      .addCase(cancelBooking.rejected, (state, action) => {
        state.cancelBooking = action.payload;
      })
      .addCase(checkBookingValidation.fulfilled, (state, action) => {
        state.bookingvalidationResponse = action.payload;
      })
      .addCase(completeBookingByUser.fulfilled, (state, action) => {
        state.completeBookingResponse = action.payload;
      })
      .addCase(completeBookingByUser.rejected, (state, action) => {
        state.completeBookingResponse = action.payload;
      });
    //   .addCase(stripeSessionGet.pending, (state, action) => {
    //     state.stripeSession = action.payload;
    //   })
    //   .addCase(stripeSessionGet.fulfilled, (state, action) => {
    //     state.stripeSession = action.payload;
    //   })
    //   .addCase(stripeSessionGet.rejected, (state, action) => {
    //     state.stripeSession = action.payload;
    //   });
  },
});

export const {
  setBookingData,
  setPersonalDetailsData,
  setDocumentsData,
  setWithDriver,
  setBookingImageObj,
  setCarId,
  cleanBookingData,
  setCarRent,
  clearBookCarData,
  setBookingAmount,
  setBookingDays,
  cleanCompleteBookingResponse,
  cleanBookingDataWithFilter,
} = bookingSlice.actions;
export default bookingSlice.reducer;
